module.exports = __webpack_public_path__ + "static/media/social_media_twitter.e5c9d4a9.svg";